module.exports = __webpack_public_path__ + "static/media/suber4.5330f1b7.png";